import { render } from "./CashOnDeliveries.vue?vue&type=template&id=3e8f2f1a&scoped=true&ts=true"
import script from "./CashOnDeliveries.vue?vue&type=script&lang=ts"
export * from "./CashOnDeliveries.vue?vue&type=script&lang=ts"

import "./CashOnDeliveries.vue?vue&type=style&index=0&id=3e8f2f1a&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8f2f1a"]])

export default __exports__